import React, { useState, useEffect } from "react"
import styled from "styled-components"
import ReactPopup from "reactjs-popup"
import CloseIcon from "../../resources/img/ui/popup/account-close.svg"
import NewBespokeForm from "./NewBespokeForm"

const contentStyle = {
  width: "840px",
  margin: "auto",
  background: "transparent",
  boxSizing: "border-box",
  overflow: "auto",
  border: "none",
}

const contentStyleMobile = {
  ...contentStyle,
  width: "100%",
  maxWidth: "840px",
  margin: "auto",
  height: "auto",
  overflow: "auto",
  border: "none",
}

const overlayStyle = {
  overflowY: "auto",
  background: "rgba(0, 0, 0, 0.45)",
}

const CloseButton = styled.button`
  cursor: pointer;
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
  position: absolute;
  top: 32px;
  right: 32px;
  width: 23px;
  height: 23px;
  img {
    display: block;
    width: 100%;
    height: auto;
  }
`
const Container = styled.div`
    position: relative;
    margin: auto;
`

const PopupContent = styled.div`
  position: relative;
  background: #fff;
  min-width: 3rem;
  opacity: ${props => props.hide ? "0" : "1"};
  pointer-events: ${props => props.hide ? "none" : "all"};
  min-height: 175px;
  min-width: 175px;

  @media (min-width: 720px) {
    border: 1px solid #000;
    background: #f8f5f3;
  }
`

const BespokePopup = ({ isOpen, close }) => {
  const [width, setWidth] = useState(0)
  const [formLoaded, setFormLoaded] = useState(false)

  useEffect(() => {
    const updateWindowDimensions = () => {
      if (typeof window !== "undefined") {
        setWidth(window.innerWidth)
      }
    }
    updateWindowDimensions()
    window.addEventListener("resize", updateWindowDimensions)
    return () => {
      window.addEventListener("resize", updateWindowDimensions)
    }
  })

  return (
    <div>
      <ReactPopup
        open={isOpen}
        onClose={close}
        closeOnDocumentClick
        contentStyle={width >= 720 ? contentStyle : contentStyleMobile}
        overlayStyle={overlayStyle}
      >
        <Container >
          <PopupContent hide={!formLoaded}>
            <CloseButton onClick={close}>
              <img src={CloseIcon} alt="close" />
            </CloseButton>
            <NewBespokeForm
              containerId="popup-bespoke-form"
              setFormLoaded={setFormLoaded}
              formLoaded={formLoaded}
            />
            {/* <HubspotBespokeForm
              containerId="popup-bespoke-form"
              setFormLoaded={setFormLoaded}
            /> */}
          </PopupContent>
          {/* {!formLoaded && <LoaderWrapper><Loader/></LoaderWrapper>} */}
        </Container>
      </ReactPopup>
    </div>
  )
}

export default BespokePopup
